//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @author Rico
import {  getQueryValue } from "@/utils/index";
import { providerJumpber } from "@/api/account";

const LoginTypeMap = {
  qq: 5,
  weibo: 6,
  weixin: 7,
  dingtalk: 9,
  google: 10,
  facebook: 11,
  twitter: 12,
};

export default {
  name: "ThirdPartyLogin",

  componentName: "ThirdPartyLogin",

  data: function () {
    return {
      logins: [],
    };
  },

  mounted: function () {
    const lang = getQueryValue("lang") || document.documentElement.lang || "en";
    if (lang === "zh") {
      this.logins = ["weixin", "qq", "weibo", "dingtalk"];
    } else {
      this.logins = ["google", "facebook", "twitter"];
    }
  },

  methods: {
    thirdPartyLogin: async function (name) {
      const url = await this.getLoginURL(name);
      window.location.href = url;
    },

    getLoginURL: async function (provider) {
      const language =
        getQueryValue("lang") || document.documentElement.lang || "en";
      const type = LoginTypeMap[provider];
      const href = window.location.href;
      const jump_url =
        href.indexOf("?") > -1
          ? href + "&action=login"
          : href + "?action=login";
      let url;
      try {
        const result = await providerJumpber(
          language,
          jump_url,
          provider,
          type
        );
        url = result.data.url;
      } catch (e) {
        console.log(e);
      }
      return url;
    },
  },
};
